module.exports = __webpack_public_path__ + "img/gb862_2.prt.77e8a3c8.jpg";